import React from "react";
import {
    VendorMailSvg,
    VendorDownloadSvg,
} from "../../../components/CommonSvg";
import {
    senderName,
    attachmentUrl,
    downloadAttachment,
    fileKind,
    initials,
    longStamp,
} from "./ticketUtils";

const ConversationMessage = ({ mail, avatarColor }) => (
    <div className="vp-tk-cmsg">
        <div className="vp-tk-ch">
            <span className="vp-tk-av" style={{ background: avatarColor }}>
                {initials(senderName(mail.fromEmail))}
            </span>
            <div className="vp-tk-who">
                <b>{senderName(mail.fromEmail)}</b>{" "}
                <span className="em">&lt;{mail.fromEmail}&gt;</span>
                <div className="vp-tk-cdt">{longStamp(mail.createdDate)}</div>
            </div>
            <span className="vp-tk-lab pub">
                <VendorMailSvg size={12} />
                Email
            </span>
        </div>
        {mail.subject && (
            <div className="vp-tk-csubj">
                <VendorMailSvg />
                <span>{mail.subject}</span>
            </div>
        )}
        <div className="vp-tk-cbody">
            <p>{mail.body}</p>
        </div>
        {mail.attachments?.length > 0 && (
            <div className="vp-tk-atts">
                {mail.attachments.map((file) => {
                    const kind = fileKind(file.filename);
                    const href = attachmentUrl(file.path);
                    return (
                        <div className="vp-tk-att" key={file.attachmentId}>
                            <a
                                className="vp-tk-att-open"
                                href={href}
                                target="_blank"
                                rel="noreferrer"
                                title={`Open ${file.filename}`}
                            >
                                <span className={`vp-tk-fi ${kind.cls}`}>
                                    {kind.label}
                                </span>
                                <span className="vp-tk-att-text">
                                    <b>{file.filename}</b>
                                    <em>{kind.type}</em>
                                </span>
                            </a>
                            <button
                                type="button"
                                className="vp-tk-att-dl"
                                title={`Download ${file.filename}`}
                                onClick={() => downloadAttachment(href, file.filename)}
                            >
                                <VendorDownloadSvg size={16} />
                            </button>
                        </div>
                    );
                })}
            </div>
        )}
    </div>
);

export default ConversationMessage;
